import React from 'react';

import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/Monitoring';
import block from 'propmods';

import { getMonitoringLabels } from '../../api';
import { useLoadingData } from '../../hooks/useLoadingData';
import { Skill } from '../../model/skill';
import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary';
import { FormError } from '../Form/FormError';
import { Loading } from '../Loading/Loading';
import { MonitoringPageDashboard } from '../MonitoringPageDashboard/MonitoringPageDashboard';
import { PageHeadline } from '../Typo/Typo';

import './MonitoringPage.scss';

const t = i18n(keyset);
const b = block('MonitoringPage');

interface Props {
    skill: Skill;
}

const MonitoringPageLoader: React.FC<Props> = ({ skill }) => {
    const { loadingMeta } = useLoadingData({
        loader: async () => getMonitoringLabels(),
    });
    const { data: solomonLabels, state } = loadingMeta;

    if (state === 'loading') {
        return <Loading centered />;
    }

    if (state === 'error') {
        return <FormError>{t('error')}</FormError>;
    }

    return <MonitoringPageDashboard skill={skill} solomonLabels={solomonLabels!} />;
};

const MonitoringPage: React.FC<Props> = ({ skill }) => {
    return (
        <ErrorBoundary withHomepageLink>
            <div {...b()}>
                <PageHeadline title={t('header')} />

                {skill.onAir ? (
                    <MonitoringPageLoader skill={skill} />
                ) : (
                    <div {...b('stub')}>{t('error-no-public')}</div>
                )}
            </div>
        </ErrorBoundary>
    );
};

export default MonitoringPage;
